<template>
  <div class="affirm">
    <div v-if="showOpen" class="Header">
      <span>i</span>
      <p>若页面点击无效，请移步微信小程序出单。</p>
    </div>
    <div v-show="show" class="step">
      <ul>
        <li :id="page === '1' ? 'atpresent' : ''" class="routeL" :class="schedule >= 1 ? 'schedule' : ''" @click="fulcrum('1')">
          <p>1</p>
          <span>基础信息</span>
        </li>
        <li :id="page === '2' ? 'atpresent' : ''" class="routeL" :class="schedule >= 2 ? 'schedule' : ''" @click="fulcrum('2')">
          <p>2</p>
          <span>人员信息</span>
          <div />
        </li>
        <li :id="page === '3' ? 'atpresent' : ''" class="routeL" :class="schedule >= 3 ? 'schedule' : ''" @click="fulcrum('3')">
          <p>3</p>
          <span>车险报价</span>
          <div />
        </li>
        <li :id="page === '4' ? 'atpresent' : ''" class="routeL" :class="schedule >= 4 ? 'schedule' : ''" @click="fulcrum('4')">
          <p>4</p>
          <span>补充信息</span>
          <div />
        </li>
      </ul>
    </div>
    <div>
      <!-- 这里有个关于步骤条的问题提醒,将<keep-alive>套在此处是因为,套在app.vue
        中会出现进入报价页面还留有上一单数据的问题,可通过刷新解决,但体验较差-->
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
    <!-- 可回溯提示谈框 -->
    <van-popup v-model="showTracBack" style="border-radius: 8px;" :close-on-click-overlay="isClose">
      <div class="TracBackTicket">
        <div class="box">
          <div class="title">
            温馨提示
          </div>
          <div class="context">
            <div>① 您即将进入投保流程</div>
            <div>② 请仔细阅读并确认保险条款等相关内容</div>
            <div>③ 您的投保操作将被记录</div>
          </div>
          <div class="agreeBtn" @click="agree">
            同意
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import api from '@/api/api.js'
// import commonUtils from '@/utils/common.js'
// import checkFormat from "@/utils/checkFormat.js"
export default {
  data() {
    return {
      showOpen: false, // 控制页面提示（安卓10兼容问题）
      page: '1',
      schedule: '1',
      show: true,

      // 可回溯
      isClose: false,
      showTracBack: false
    }
  },
  computed: {
    getStep() {
      return this.$store.state.step
    },
    getShow() {
      return this.$store.state.show
    },
    getSteps() {
      return this.$store.state.steps
    },
    getAlter() {
      return this.$store.state.alter
    }
  },
  watch: {
    'getStep': function(newVal, oldVal) {
      this.page = newVal
      this.$store.commit('setPage', this.page)
      if (newVal > this.schedule) {
        this.schedule = newVal
      }
      if (newVal === '1') {
        this.$router.push('/car/vehicle')
      } else if (newVal === '2') {
        this.$router.push('/car/relate')
      } else if (newVal === '3') {
        if (localStorage.getItem('whetherFeeChangeArea') === '1') {
          this.$router.push('/car/newQuote')
        } else {
          this.$router.push('/car/quote')
        }
      } else if (newVal === '4') {
        this.$router.push('/car/supplementary')
      }
    },
    'getSteps': function(newVal, oldVal) {
      this.schedule = newVal
    },
    'getShow': function(newVal, oldVal) {
      this.show = newVal
    },
    'getAlter': function(newVal, oldVal) {
      this.page = this.$store.state.alters
      this.schedule = this.$store.state.alters
      this.$store.commit('setVariation', true)
      this.$store.commit('setPage', this.page)
    }
  },
  mounted() {
    // checkFormat.handleURLkey()
    // this.$store.commit('setStep','1')
    this.$store.commit('setLabel', false)
    this.$store.commit('setEntrance', 0)
    this.$store.commit('setTotal', {})
    this.$store.commit('setSteps', '0')
    this.$store.commit('setAlter', '1')
    this.$store.commit('setParams', {})
    const URL = window.location.href
    if (localStorage.getItem('setPolicyNo')) {
      this.switchs = true
      this.$http.get(api.fastRenewal + '?orderOrigin=' + localStorage.getItem('setChannelCode') + '&policyNo=' + localStorage.getItem('setPolicyNo')).then(res => {
        // Toast.clear()
        // this.switchs = false
        if (res.data.rtnCode === '0000') {
          this.$store.commit('setStep', '3')
          this.$store.commit('setAlter', '3')
          this.$store.commit('setParams', res.data)
        } else {
          this.$store.commit('setStep', '1')
          this.$store.commit('setParams', res.data)
        }
      }).catch(error => {
        // Toast.clear()
        // this.switchs = false
        console.log(error)
      })
    } else {
      // let URL = window.location.href
      const receive = URL.split('#/')[1]
      if (receive !== 'car/confirm') {
        this.$store.commit('setStep', '1')
      }
    }
    this.$store.commit('setChannelCode', localStorage.getItem('setChannelCode'))
    this.$store.commit('setTerminalId', localStorage.getItem('setTerminalId'))
    if (URL.indexOf('showOpenToast=true') !== -1) {
      this.showOpen = true
    } else {
      this.showOpen = false
    }

    // 20200919做可回溯判断
    this.getTraceBack()
  },
  methods: {
    fulcrum(value) {
      if (value > Number(this.schedule)) {
        return ''
      }
      if (value === '1') {
        this.$router.replace('/car/vehicle')
      } else if (value === '2') {
        this.$router.replace('/car/relate')
      } else if (value === '3') {
        if (localStorage.getItem('whetherFeeChangeArea') === '1') {
          this.$router.push('/car/newQuote')
        } else {
          this.$router.push('/car/quote')
        }
      } else if (value === '4') {
        this.$router.replace('/car/supplementary')
      }
    },
    // 可回溯
    getTraceBack() {
      console.log('get trace back flag')
      // this.$store.commit('setTraceBack', true)
      this.showTracBack = true
      // try {
      //   this.$http.post(api.getByCodeType, { codeType: 'TraceableSwitch' })
      //     .then(res => {
      //       const result = res.data || []
      //       for (const item in result) {
      //         if (result[item].codeType === 'TraceableSwitch') {
      //           // 如果进行可回溯 （返回的可能是1  也可能是 '1'）
      //           if (result[item].codeCode == '1') {
      //             // tip--上生产后此处需要修改js的路径
      //             // 在设置了可回溯标识为1 并且进来的是C端用户时，才进行可回溯
      //             if (commonUtils.isClient()) {
      //               this.$store.commit('setTraceBack', true)
      //               this.showTracBack = true
      //               // let jsURl = 'https://staticdaily.zhongan.com/website/isee-poc/eye.js'
      //               // 根据环境变量判断，如果是生产环境，则加载生产环境地址，否则加载sit地址
      //               let jsURl = ''
      //               if (process && process.env && process.env.ENV_CONFIG === 'prod') {
      //                 jsURl = 'https://saletrace.zking.com/eye.js'
      //               } else {
      //                 jsURl = 'https://test-saletrace.zking.com:20001/eye.js'
      //               }
      //               commonUtils.loadJs(jsURl)
      //             }
      //           }
      //         }
      //       }
      //     })
      // } catch (e) {
      // }
    },
    agree() {
      this.showTracBack = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import './carInfo.scss'
</style>




// WEBPACK FOOTER //
// src/pages/car/carInfo/index.vue